import { Card } from '@core/types/card-deck';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import { FC } from 'react';

import DesktopContent from './CardDesktopContent';
import MobileContent from './CardMobileContent';
import ImageDialog from './ImageDialog';

type FeatureDialogProps = {
  card: Card;
  onClose?: () => void;
};

const CardDialog: FC<FeatureDialogProps> = ({ card, onClose }) => {
  const theme = useTheme();
  const isMD = useMediaQuery(theme.breakpoints.up('md'));
  const showDesktop = isMD && !!(card.shop || card.video);

  return (
    <ImageDialog
      content={showDesktop ? <DesktopContent card={card} /> : <MobileContent card={card} />}
      image={`/img/header-kampfkunst-feature-${card.image}.jpg`}
      onClose={onClose}
      title={card.name}
    />
  );
};

export default CardDialog;
